import { firebaseDatabase, firebaseStorage } from "../config/firebase.config";
import { MESSAGE_TYPES as msg } from "../utils/js/constants";

const productsStorageRef = firebaseStorage.ref();
const productsDatabaseRef = firebaseDatabase.ref("/products");

const createProduct = (product) => {
    return productsDatabaseRef.push(product)
        .then(() => ({ message: msg.PRODUCT_SUCCESS, result: null, error: false }))
        .catch((error) => ({ message: msg.PRODUCT_ERROR, result: null, error: error }));
}

const deleteProduct = (key) => productsDatabaseRef.child(key).remove()
  .then(() => ({ message: msg.PRODUCT_DELETE, result: null, error: false }))
  .catch((error) => ({
      message: msg.PRODUCT_DELETE_ERROR, result: null, error: error
  }));

const deleteAllProducts = () => {
    productsDatabaseRef.remove()
        .then(() => ({ message: msg.PRODUCT_DELETE, result: null, error: false }))
        .catch((error) => ({
            message: msg.PRODUCT_ERROR, result: null, error: error
        }));
}

const getAllProducts = (callback = () => {}) => {
    productsDatabaseRef.on('value', (snapshot) => {
        const allProductList = [];

        snapshot.forEach((childSnapshot) => {
            let childKey = childSnapshot.key;
            let childData = childSnapshot.val();
            childData.Id = childKey;
            allProductList.push(childData);
        });

        callback(allProductList);
    });
}

const getProductByValue = (value, callback = () => { }) => {

    let response = getProductByField('nome', value);

    if (response && Object.entries(response.result).length === 0) {
        response = getProductByField('codigo', value);
    }

    callback(response);
}

const getProductByField = (field, value) => {

    let productReturned = {};

    productsDatabaseRef.orderByChild(field).equalTo(value).on('value', (snapshot) => {

        snapshot.forEach((childSnapshot) => {
            let childKey = childSnapshot.key;
            let childData = childSnapshot.val();
            childData.Id = childKey;
            productReturned = childData;
        });
    });

    return { message: msg.PRODUCT_SUCCESS, result: productReturned, error: null }
}

const updateProduct = (key, product) => {
    return productsDatabaseRef.child(key).update(product)
        .then(() => ({ message: msg.PRODUCT_UPDATE, result: product, error: false }))
        .catch((error) => ({
            message: msg.PRODUCT_ERROR, result: null, error: error
        }));
}

// fileName will be the code of the product, which is unique ex: KL21.png
const uploadProductImage = async (file, fileName, callback = () => {}) => {
    const productImagesRef = productsStorageRef.child(`products/${fileName}`);
    let data = {};
    let uploadTask = await productImagesRef.put(file);

    uploadTask.ref.getDownloadURL().then((downloadURL) => {
        data = { message: msg.PRODUCT_IMAGE_UPLOAD, result: downloadURL, error: null};
    }).catch((error) => {
        data = { message: msg.PRODUCT_IMAGE_UPLOAD_FAILURE, result: null, error: error};
    }).finally(() => callback(data));
}

export {
    createProduct,
    deleteAllProducts,
    deleteProduct,
    getAllProducts,
    getProductByValue,
    updateProduct,
    uploadProductImage,
};
